import { render, staticRenderFns } from "./AlfaPortfolioDiversification.vue?vue&type=template&id=61c58d8a&scoped=true&"
import script from "./AlfaPortfolioDiversification.vue?vue&type=script&lang=js&"
export * from "./AlfaPortfolioDiversification.vue?vue&type=script&lang=js&"
import style0 from "./AlfaPortfolioDiversification.vue?vue&type=style&index=0&id=61c58d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c58d8a",
  null
  
)

export default component.exports